import { GET_NODES } from "constants/assignments";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_NODES}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
